import type { VocabularySuggestWord } from "site/services/editor-vocabulary.service";

export type SuggestNewWordsModalContext = {
  words: VocabularySuggestWord[];
  onConfirm: (words: VocabularySuggestWord[]) => void | Promise<void>;
};

let context: SuggestNewWordsModalContext | null = null;

export function openSuggestNewWordsModal(next: SuggestNewWordsModalContext): void {
  context = next;
}

export function getSuggestNewWordsModalContext(): SuggestNewWordsModalContext | null {
  return context;
}

export function clearSuggestNewWordsModalContext(): void {
  context = null;
}
